import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import {getColor, getFontWeight} from '../../styles/utils';
import {View} from '../View';

export const menu = css`
  border-radius: 8px;
  background-color: ${getColor('background1')};
`;

export const singleValue = css<{selectProps}>`
  color: ${getColor('text1')};
`;

const optionPrimary = css`
  color: ${getColor('button.fill1')};
  background-color: ${getColor('background3')};
`;

const optionSecondary = css`
  color: ${getColor('button.fill2')};
  background-color: ${getColor('background5')};
`;

export const option = css<
  Required<StyledProps> & {
    isDisabled: boolean;
    isFocused: boolean;
    isSelected: boolean;
  }
>`
  color: ${getColor('text1')};
  background-color: transparent;
  font-size: 14px;
  height: 47px;
  font-weight: ${getFontWeight('semibold')};
  display: flex;
  align-items: center;

  &:hover {
    ${p => {
      switch (p.scheme) {
        case 'primary':
          return optionPrimary;
        case 'secondary':
          return optionSecondary;
      }
    }}
  }

  ${p =>
    (p.isSelected || p.isDisabled) &&
    css`
      color: ${getColor('text3')};
      background-color: transparent;

      &:hover {
        color: ${getColor('text3')};
        background-color: transparent;
      }
    `};

  ${p =>
    p.isFocused &&
    (() => {
      switch (p.scheme) {
        case 'primary':
          return optionPrimary;
        case 'secondary':
          return optionSecondary;
        default:
          return '';
      }
    })()};
`;

const containerBorder = css<StyledProps>`
  border: 1px solid ${p => getColor(p.error ? 'error' : 'border2')};
`;

/**
 * Basic shared css for any renderer.
 */
const base = css<StyledProps>`
  box-sizing: border-box;
  border: none;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  color: ${getColor('text3')};
  font-size: 14px;
  min-height: 47px;
  transition: all ease 0.2s;
  min-width: 200px;
  padding: 5px;
  background-color: ${p =>
    p.theme.id === 'light' ? getColor('background1') : getColor('background2')};
  box-shadow: none;

  ${containerBorder};

  &:hover {
    ${containerBorder};
  }
`;

const web = css<StyledProps>`
  box-sizing: border-box;
  ${base}
`;

/**
 * If we use SC to style the container (via components prop)
 * the portaling feature won't work.
 */
export const Container = styled(View)<StyledProps>`
  position: relative;
  display: block;

  .react-select__control {
    ${web};
    cursor: pointer;
  }

  .react-select__input {
    color: ${getColor('text1')} !important;
  }

  .react-select__placeholder {
    color: ${getColor('text3')} !important;
  }
`;
